import React from "react";

export default ({ question }) => <li className="wrong">
    {question.question.replace(
        "____",
        question.alternatives[0].replace(/`/g, "")
      )}
</li>;


// WEBPACK FOOTER //
// ./src/components/quiz/Wrong.js